import script from "./incineratedPieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./incineratedPieChart.vue?vue&type=script&setup=true&lang=js"

import "./incineratedPieChart.vue?vue&type=style&index=0&id=48ebfe14&lang=css"

const __exports__ = script;

export default __exports__